/* ============ LOS PROGRAMAS GUIADOS ============
   CLONADO TAL CUAL de FisioVisión · prototipo/paciente.html (líneas 6966-7031).
   NO SE REESCRIBE NI SE "MEJORA": los tiempos, las palabras y los avisos son
   el encargo de Ann del 8-ago-2026. Ver NORMA_CLONAR_NO_INVENTAR.md.

   Pequeñas guías que llevan al paciente de la mano mientras hace el
   ejercicio: le dicen cuándo coger aire y cuándo soltarlo, y cuentan
   por él. Son un APOYO del ejercicio, no una pantalla aparte, y por
   eso el acceso es una tarjeta pequeña dentro de la ficha.

   El motor es genérico: se define por PARTES y por FASES, así que
   entra un programa nuevo sin tocar una línea del motor.
   ============================================================== */
export const PROGRAMAS = {
  /* KEGEL · tiempos exactos del encargo de Ann (8-ago-2026):
     prep 3s · P1 8x(3+6) · descanso 20 · P2 8x(6+6) · descanso 20 · P3 12x(1+1)
     Total ~ 3 min 55 s. */
  kegel: {
    n: 'Kegel guiado',
    sub: 'Te digo cuándo contraer y cuándo soltar, y cuento por ti',
    prep: 3,
    descanso: 20,
    partes: [
      { n:'Lentas suaves', reps:8, fases:[
          { t:'CONTRAE',  sub:'cierra y eleva hacia dentro · exhala', s:3, tipo:'in'  },
          { t:'Relaja',   sub:'suelta del todo e inhala despacio',   s:6, tipo:'out' } ]},
      { n:'Lentas largas', reps:8, fases:[
          { t:'CONTRAE',  sub:'cierra y eleva hacia dentro · exhala', s:6, tipo:'in'  },
          { t:'Relaja',   sub:'suelta del todo e inhala despacio',   s:6, tipo:'out' } ]},
      { n:'Rápidas', reps:12, fases:[
          { t:'CONTRAE',  sub:'corto y seco',    s:1, tipo:'in'  },
          { t:'Relaja',   sub:'suelta del todo', s:1, tipo:'out' } ]}
    ],
    /* los once avisos, EXACTOS */
    avisos: [
      'No aguantes la respiración: nada de apneas',
      'No aprietes glúteos ni abdomen, solo el suelo pélvico',
      'No empujes hacia abajo: cierra y eleva hacia dentro',
      'No aprietes muslos ni aductores',
      'Intensidad media, submáxima — no hace falta el máximo',
      'Columna recta, pelvis neutra, hombros y mandíbula sueltos',
      'Pocas y bien hechas, mejor que muchas mal',
      'No fuerces: relaja por completo entre repeticiones',
      'No siempre boca arriba: progresa a la posición sentada, a cuatro patas y de pie',
      'Complementa con los ejercicios del Método',
      'Calidad mejor que cantidad: concéntrate'
    ],
    /* las cuatro láminas de Ann · sólo las tiene el Kegel */
    laminas: true
  },

  respiracion: {
    n: 'Respiración guiada',
    sub: 'Te digo cuándo coger aire y cuándo soltarlo',
    partes: [
      { n:'Respiración diafragmática', reps:10, fases:[
          { t:'Coge aire',       sub:'por la nariz, hinchando la barriga', s:4, tipo:'in'  },
          { t:'Suelta despacio', sub:'por la boca, sin prisa',             s:6, tipo:'out' }
      ]}
    ],
    avisos: [
      'La mano del pecho casi no se mueve. La de la barriga, sí.',
      'No fuerces: si te falta el aire, respira normal un momento.',
      'Los hombros, quietos y bajos.',
      'Suelta más despacio de lo que coges.'
    ],
    laminas: false
  }
};
